import { render, staticRenderFns } from "./LegendLabel.vue?vue&type=template&id=371f1051&scoped=true&"
import script from "./LegendLabel.vue?vue&type=script&lang=js&"
export * from "./LegendLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371f1051",
  null
  
)

export default component.exports